import React from "react";
import cx from "classnames";
import debounce from "lodash/debounce";
import { host, Common, Nav, Home } from "@Api";
import ga from "../../lib/ga";
import { CaretRightOutlined } from "@ant-design/icons";
import { g4 as ga4Collect } from "../../utils/helper";

const { www } = host;

const image = "https://img.8891.com.tw/next";

const { fetchSearchMentions, fetchSearchRecommend, fetchSearchSuggest } = Nav;
const { postInitialCollect } = Common;
// const { fetchActiveInfo } = Home;

interface IProps {
  visible: boolean;
  type: string;
  isFixed: boolean;
  toggle: (visible: boolean) => void;
}

interface IAds {
  text: string;
  type: string;
  brandId?: number;
  kindId?: number;
  articleId?: number;
  articleType?: number;
  ads?: {
    id: string;
    type: string;
    title: string;
    adclick: string;
  };
}

interface IResultList {
  type: string;
  data: {
    icon: string;
    title: string;
    brandId: number;
    brandName: string;
    inquiry: number;
    kindId: number;
    kindName: string;
    saleStop: number;
    articleId: number;
    articleType: number;
  };
}
interface IState {
  cursor: number;
  mentions: Array<{ text: string }>;
  resultList: IResultList[];
  recommend: IAds[];
  default: IAds[];
  mentionsHide: boolean;
  keyword: string;
  placeholder: string;
  ads?: IAds["ads"];
  activityStatus: 0 | 1;
  historyShow: boolean;
  resultShow: boolean;
}

class SearchPopover extends React.Component<IProps, IState> {
  readonly state: IState = {
    cursor: -1,
    mentions: [],
    mentionsHide: true,
    recommend: [],
    default: [],
    placeholder: "",
    keyword: "",
    ads: undefined,
    activityStatus: 0,
    historyShow: false,
    resultShow: false,
    resultList: [],
  };

  private setTimeDuration: ReturnType<typeof setTimeout> | undefined;
  private inputRef = React.createRef<HTMLInputElement>();
  private duration: any = [];
  private browsingHistoryList: any = [];
  private pageName: string = "";

  private mention = debounce((value: string) => {
    // this.search(value);
    this.suggest(value);
  }, 500);

  private handleInput = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    if (value === "") {
      this.setState({
        historyShow: false,
        resultShow: false,
      });
    }
    this.setState({
      keyword: value,
    });
    this.mention(value);
  };

  private moveCursor = (index: number) => {
    const { mentions } = this.state;
    const max = mentions.length - 1;
    const current = index < 0 ? max : index > max ? 0 : index;
    this.setState({
      cursor: current,
    });
  };

  private search = async (keyword: string) => {
    let mentions: Array<{ text: string }> = [];
    if (!!keyword) {
      const res = await fetchSearchMentions({ keyword });
      if (res && res.status === 12000) {
        mentions = [...res.data.list];
      }
    }
    this.setState({
      cursor: -1,
      mentions,
      mentionsHide: false,
    });
  };

  private suggest = async (keyword: string) => {
    let resultList: Array<any> = [];
    if (!!keyword) {
      const res = await fetchSearchSuggest({ keyword });
      if (res && res.status === 12000) {
        resultList = [...res.data.list];
      }
    }
    this.setState(
      {
        resultList,
        historyShow: false,
        resultShow: true,
      },
      () => {
        if (this.state.resultShow) {
          this.state.resultList.forEach((item) => {
            ga4Collect("element_exposured", {
              page_name: this.pageName,
              module: "搜索欄",
              sub_module: "搜索框",
              element: "下拉框推薦詞",
              element_id: item.data.title,
            });
          });
        }
      },
    );
  };

  private highLight = (str, keyword) => {
    try {
      return str.replace(new RegExp(keyword, "gmi"), (match) => {
        return `<span style="color:#ff3232">${match}</span>`;
      });
    } catch (error) {
      return str;
    }
  };

  private handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const { cursor } = this.state;
    switch (e.keyCode) {
      case 38:
        e.preventDefault();
        // this.moveCursor(cursor - 1);
        break;
      case 40:
        e.preventDefault();
        // this.moveCursor(cursor + 1);
        break;
      case 13:
        e.preventDefault();
        this.jump(cursor);
        break;
      default:
        break;
    }
  };

  private handleContainerClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target;
    if ((target as any).classList.contains("tc-search-mention") || (target as any).id === "tcSearchInput") {
      return;
    }
    this.setState({
      mentionsHide: true,
      cursor: -1,
    });
  };

  private handleFocus = () => {
    this.setState(
      {
        historyShow: this.state.keyword === "" && this.browsingHistoryList.length > 0 ? true : false,
        resultShow: this.state.keyword !== "" ? true : false,
        placeholder: "",
      },
      () => {
        if (this.state.historyShow) {
          this.browsingHistoryList.forEach((item) => {
            ga4Collect("element_exposured", {
              page_name: this.pageName,
              module: "搜索欄",
              sub_module: "搜索框",
              element: "下拉歷史推薦詞",
              element_id: item,
            });
          });
        }
        if (this.state.resultShow) {
          this.state.resultList.forEach((item) => {
            ga4Collect("element_exposured", {
              page_name: this.pageName,
              module: "搜索欄",
              sub_module: "搜索框",
              element: "下拉框推薦詞",
              element_id: item.data.title,
            });
          });
        }
      },
    );
    if (this.state.mentions.length > 0) {
      this.setState({
        mentionsHide: false,
      });
    }

    this.setTimeDuration && clearInterval(this.setTimeDuration);
    setTimeout(() => {
      this.setTimeDuration && clearInterval(this.setTimeDuration);
    }, 800);
  };

  private handleBlur = () => {
    setTimeout(() => {
      this.setState({
        historyShow: false,
        resultShow: false,
        placeholder: this.duration[0],
      });
    }, 200);
    this.intervalDuration(this.duration.length);
  };

  private handleMouse = (index: number) => {
    this.moveCursor(index);
  };

  private jump = (index?: number) => {
    const { mentions, keyword, placeholder, ads } = this.state;
    const adsObj = this.state.default.filter((_) => _.ads)[0];
    let query = "";

    if (!index) {
      if (!!keyword) {
        query = keyword;
      } else {
        query = placeholder;
        // if (ads) {
        //   postInitialCollect(ads, "click", "searchViewButton");
        // }
      }
    } else {
      const current = mentions[index];
      if (current) {
        query = current.text;
      } else {
        query = keyword;
      }
    }

    if (adsObj) {
      this.ad(adsObj);
      adsObj.ads && adsObj.ads.adclick !== "" && query === adsObj.ads?.title
        ? (location.href = adsObj.ads.adclick)
        : this.historyItem(query);
    } else {
      this.historyItem(query);
    }
  };

  private historyItem = (query?: string) => {
    const index = this.browsingHistoryList.findIndex((res: any) => res === query);
    const list: any = this.browsingHistoryList || [];

    if (index !== -1) {
      list.splice(index, 1);
    }
    query?.trim() !== "" && list.unshift(query);
    this.browsingHistoryList = [...list];

    localStorage.setItem("browsingHistoryList", JSON.stringify(list));
    window.open(`${www}/index-search.html?keyword=${query}`);
  };

  private fetch = async () => {
    const res = await fetchSearchRecommend({ ads: 1 });

    this.duration = res.data.default.map((item: any) => item.text);
    this.duration.reverse();
    if (res && res.status === 12000) {
      const { hotSearch, default: defaultData } = res.data;

      this.setState({
        recommend: hotSearch,
        default: defaultData,
      });
    }

    let dur = this.duration?.length;
    this.setTimeDuration = setInterval(() => {
      dur--;
      if (dur <= 0) {
        this.setTimeDuration && clearInterval(this.setTimeDuration);
        this.intervalDuration(this.duration.length);
      }
      this.setState({
        placeholder: this.duration[dur],
      });
    }, 3000);
  };

  checkAndPostInitialCollect(dataArray: any) {
    Array.isArray(dataArray) && !!dataArray.length &&
      dataArray.forEach((item) => {
        item.ads && postInitialCollect(item.ads, "show", "searchKeyword");
      });
  }

  intervalDuration(duration: number) {
    let dur = duration;
    this.setTimeDuration = setInterval(() => {
      dur--;
      if (dur <= 0) {
        this.setTimeDuration && clearInterval(this.setTimeDuration);
        this.intervalDuration(this.duration.length);
      }
      this.setState({
        placeholder: this.duration[dur],
      });
    }, 3000);
  }

  private close = () => {
    this.setState({
      cursor: -1,
      mentions: [],
      mentionsHide: true,
      keyword: "",
    });
    this.props.toggle(false);
  };

  private ad = (data: IAds) => {
    data.ads && postInitialCollect(data.ads, "click", "searchKeyword");
  };

  // async fetchActiveInfo() {
  //   const res = await fetchActiveInfo({ name: "buying-party" });
  //   if (res?.status === 12000) {
  //     this.setState({
  //       activityStatus: 1,
  //     });
  //   }
  // }

  async ga4Item() {
    const obj = this.state.default.filter((_) => _.text === this.state.placeholder)[0];
    const params = {
      page_name: this.pageName,
      module: "搜索欄",
      sub_module: "搜索框",
      element: this.state.keyword === "" ? "搜索框推薦詞" : "搜索框輸入詞",
      element_id: this.state.keyword === "" ? this.state.placeholder : this.state.keyword,
      object_type: obj && (obj.type === "article" ? "文章" : obj.type === "kind" ? "車款" : ""),
      object_id: obj && (obj.type === "article" ? obj.articleId : obj.type === "kind" ? obj.kindId : ""),
    };
    this.state.keyword !== "" && ga4Collect("element_exposured", params);
    ga4Collect("element_clicked", params);
  }

  componentDidMount() {
    const browsingHistoryList = localStorage.getItem("browsingHistoryList");
    if (browsingHistoryList) {
      this.browsingHistoryList = [...JSON.parse(browsingHistoryList)];
    }
    this.fetch();
    this.pageName = `${window.location.origin.indexOf("auto") > -1
      ? "搜尋輸入頁"
      : window.location.pathname === "/"
        ? "首頁"
        : window.location.pathname.indexOf("Summary.html") > -1
          ? "綜述頁-首頁"
          : "搜尋輸入頁"
      }`;
  }

  componentDidUpdate(prevProps: IProps) {
    let first = true;
    if (!prevProps.visible && this.props.visible && this.inputRef.current) {
      if (first) {
        this.state.recommend.forEach((item) => {
          ga4Collect("element_exposured", {
            page_name: this.pageName,
            module: "搜索欄",
            sub_module: "熱門",
            element: "熱門推薦詞",
            element_id: item.text,
            object_type: item.type === "kind" ? "車款" : "廠牌",
            object_id: item.type === "kind" ? item.kindId : item.brandId,
          });
        });
        this.state.default.forEach((item) => {
          ga4Collect("element_exposured", {
            page_name: this.pageName,
            module: "搜索欄",
            sub_module: "搜索框",
            element: "搜索框推薦詞",
            element_id: item.text,
            object_type: item.type === "article" ? "文章" : item.type === "kind" ? "車款" : "",
            object_id: item.type === "article" ? item.articleId : item.type === "kind" ? item.kindId : "",
          });
        });
        first = false;
      }



      this.checkAndPostInitialCollect(this.state.recommend);
      this.checkAndPostInitialCollect(this.state.default);
    }
  }

  render() {
    const { visible, type, isFixed } = this.props;
    const {
      mentions,
      cursor,
      mentionsHide,
      recommend,
      keyword,
      placeholder,
      activityStatus,
      historyShow,
      resultShow,
      resultList,
    } = this.state;

    return (
      <div
        className={cx("tc-search-popover")}
        style={{ top: visible ? (type === "slim" ? "38px" : isFixed ? "0px" : "90px") : "-90vh" }}
        onClick={this.handleContainerClick}
      >
        <div className='tc-search-popover-header'>
          <img className='tc-search-popover-logo' src='https://img.8891.com.tw/v3/logo.png' />
          <span className='tc-search-popover-close' onClick={this.close} />
        </div>
        <div className='tc-search-popover-content'>
          <div className='tc-search-popover-input'>
            <input
              id='tcSearchInput'
              ref={this.inputRef}
              placeholder={placeholder}
              onChange={this.handleInput}
              onKeyDown={this.handleKeyDown}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              value={keyword}
            />
          </div>
          <button
            className='tc-search-popover-btn'
            onClick={() => {
              this.ga4Item();
              this.jump();
            }}
          >
            搜尋
          </button>

          {(historyShow || resultShow) && (
            <div className='tc-search-popover-drop'>
              {historyShow && (
                <div className='history'>
                  <p>
                    搜尋記錄{" "}
                    <span
                      onClick={() => {
                        this.browsingHistoryList = [];
                        localStorage.removeItem("browsingHistoryList");
                        this.setState({
                          historyShow: false,
                        });
                      }}
                    >
                      清除
                    </span>
                  </p>
                  <ul>
                    {Array.isArray(this.browsingHistoryList) &&
                      this.browsingHistoryList.map((item, index) => (
                        <React.Fragment key={index}>
                          {index < 8 && (
                            <li>
                              <a
                                href={`${www}/index-search.html?keyword=${item}`}
                                target='_blank'
                                onClick={() => {
                                  ga4Collect("element_clicked", {
                                    page_name: this.pageName,
                                    module: "搜索欄",
                                    sub_module: "搜索框",
                                    element: "下拉歷史推薦詞",
                                    element_id: item,
                                  });
                                }}
                              >
                                {item}
                              </a>
                            </li>
                          )}
                        </React.Fragment>
                      ))}
                  </ul>
                </div>
              )}

              {resultShow && (
                <div className='results'>
                  {Array.isArray(resultList) &&
                    resultList.map((item, index) => (
                      <React.Fragment key={index}>
                        {item.type === "brand" && (
                          <div
                            className='brand'
                            onClick={() => {
                              this.historyItem(item.data.title);
                              ga4Collect("element_clicked", {
                                page_name: this.pageName,
                                module: "搜索欄",
                                sub_module: "搜索框",
                                element: "下拉框推薦詞",
                                element_id: item.data.title,
                                object_type: "廠牌",
                              });
                            }}
                          >
                            <img src={item.data.icon} />
                            <p
                              dangerouslySetInnerHTML={{
                                __html: this.highLight(item.data.title, keyword),
                              }}
                            ></p>
                          </div>
                        )}
                        {item.type === "kind" && (
                          <div className='kind'>
                            <div
                              className='title'
                              onClick={() => {
                                this.historyItem(item.data.title);
                                ga4Collect("element_clicked", {
                                  page_name: this.pageName,
                                  module: "搜索欄",
                                  sub_module: "搜索框",
                                  element: "下拉框推薦詞",
                                  element_id: item.data.title,
                                  object_type: "車款",
                                  object_id: item.data.kindId,
                                });
                              }}
                              dangerouslySetInnerHTML={{
                                __html: this.highLight(item.data.title, keyword),
                              }}
                            ></div>
                            <div className='btn'>
                              {item.data.inquiry === 1 && (
                                <a
                                  href={`https://c.8891.com.tw/ask/price?b=${item.data.brandId}&k=${item.data.kindId}&source=首頁搜尋-輪入引導`}
                                  target='_blank'
                                  onClick={() => {
                                    ga4Collect("element_clicked", {
                                      page_name: this.pageName,
                                      module: "搜索欄",
                                      sub_module: "搜索框",
                                      element: "下拉框推薦詞",
                                      element_id: "一鍵詢價",
                                      object_type: "廠牌、車款",
                                      object_id: `${item.data.brandId}、${item.data.kindId}`,
                                    });
                                  }}
                                >
                                  一鍵詢價
                                  <CaretRightOutlined style={{ color: "#666666" }} />
                                </a>
                              )}
                              {item.data.saleStop === 0 && (
                                <a
                                  href={`https://c.8891.com.tw/photoModel-balance.html?k=${item.data.kindId}`}
                                  target='_blank'
                                  onClick={() => {
                                    ga4Collect("element_clicked", {
                                      page_name: this.pageName,
                                      module: "搜索欄",
                                      sub_module: "搜索框",
                                      element: "下拉框推薦詞",
                                      element_id: "配備",
                                      object_type: "廠牌、車款",
                                      object_id: `${item.data.brandId}、${item.data.kindId}`,
                                    });
                                  }}
                                >
                                  配備
                                  <CaretRightOutlined style={{ color: "#666666" }} />
                                </a>
                              )}
                            </div>
                          </div>
                        )}
                        {item.type === "article" && (
                          <div
                            className='article'
                            onClick={() => {
                              this.historyItem(item.data.title);
                              ga4Collect("element_clicked", {
                                page_name: this.pageName,
                                module: "搜索欄",
                                sub_module: "搜索框",
                                element: "下拉框推薦詞",
                                element_id: item.data.title,
                                object_type: "文章",
                              });
                            }}
                          >
                            <p
                              dangerouslySetInnerHTML={{
                                __html: this.highLight(item.data.title, keyword),
                              }}
                            ></p>
                          </div>
                        )}
                      </React.Fragment>
                    ))}
                </div>
              )}
            </div>
          )}
        </div>

        <div className='tc-search-popover-extra'>
          <p>熱門：</p>
          <ul>
            {Array.isArray(recommend) &&
              recommend.map((item, index) => (
                <li key={index} className={item.ads ? "tc-item-ads" : ""}>
                  <a
                    href={item.ads && item.ads.adclick ? item.ads.adclick : `/photoModel-info.html?k=${item.kindId}`}
                    target='_blank'
                    onClick={() => {
                      this.ad(item);
                      ga4Collect("element_clicked", {
                        page_name: this.pageName,
                        module: "搜索欄",
                        sub_module: "熱門",
                        element: "熱門推薦詞",
                        element_id: item.text,
                        object_type: item.type === "kind" ? "車款" : "廠牌",
                        object_id: item.type === "kind" ? item.kindId : item.brandId,
                      });
                    }}
                  >
                    {item.text}
                  </a>
                </li>
              ))}
          </ul>
        </div>
        {
          <div className='search-active-box'>
            <div
              gad='div-gpt-ad-1501058217309-0'
              gad-tag='/173427088/newcar-pc-models-interad'
              className='dfp-fluid dfp-h5'
              style={{ height: "90px", width: "690px", marginTop: "20px", display: "none" }}
            ></div>
          </div>
        }
      </div>
    );
  }
}

export default SearchPopover;
